<div class="search-screen">
  <app-side-panel
    [table]="TABLES.SEARCH"
    [showFraud]="true"
    (onSyncOrder)="reSyncOrderClick($event, true)"
    (changeColorCoding)="changeColorCoding($event)">
  </app-side-panel>
  <mat-drawer-container>
    <mat-drawer-content>
      @if (loading) {
        <pdq-progress-bar borderRadius="none" size="small" mode="indeterminate"></pdq-progress-bar>
      }

      <div class="header">
        <div class="search-icon" (click)="search()">
          <pdq-icon icon="search" size="x-large" color="var(--on-surface-light)"></pdq-icon>
        </div>
        <pdq-input
          type="text"
          placeholder="Search for anything..."
          [withIcon]="true"
          [autofocus]="true"
          [labelHidden]="true"
          [invalid]="false"
          [dirty]="false"
          [plainWhenDisabled]="false"
          variant="form"
          [value]="searchControl.value"
          background="default"
          [border]="false"
          [autocompleteMode]="false"
          autoCompletePlacement="bottom"
          [maxLength]="300"
          showBrowserAutocomplete="off"
          [control]="searchControl"
          size="large"
          [displayReset]="searchControl.value"
          (onReset)="reset()"
          (onEnter)="search()"></pdq-input>
      </div>
      @if (!loading) {
        <div class="sub-header">
          @if (searchInput) {
            <span>
              {{ orders?.length ? 'Showing results for ' + searchInput : 'No search results found...' }}
            </span>
          }
          @if (!orders?.length) {
            <div>
              Recent searches
              <pdq-options-list (onChange)="onRecentSearchClick($event)" [options]="latestSearches"> </pdq-options-list>
            </div>
          }
        </div>
      }
      @if (loading) {
        <div><skeleton-table></skeleton-table></div>
      } @else {
        @if (orders?.length) {
          <div class="search-table-container" style="padding: 16px" class="orders-wrapper">
            @if (COLUMN_OPTIONS && COLUMN_OPTIONS.length) {
              <div style="display: flex; justify-content: flex-start">
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <mat-select
                  #editcolumns
                  class="table-columns-select"
                  panelClass="pdq-mat-select--panel__multi"
                  floatlLabel="never"
                  [(ngModel)]="selectedColumns"
                  (selectionChange)="toggleColumn()"
                  [disableOptionCentering]="true"
                  multiple
                  matTooltipClass="pdq-mat-tooltip"
                  [matTooltip]="'Edit columns'">
                  <div class="pdq-mat-select--panel--header">
                    Showing {{ selectedColumns.length + '/' + COLUMN_OPTIONS.length }} columns
                  </div>
                  @for (column of COLUMN_OPTIONS; track column) {
                    <mat-option selected="selected" [value]="column.prop">
                      {{ column.name }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            }
            <app-table
              [table]="TABLES.SEARCH"
              [selected]="totalPages"
              [rows]="temp"
              [rowActions]="rowActions"
              [rowsLoading]="loading"
              [columnsSettings]="columns"
              [focusedRowId]="focusedOrderId"
              [perPageActiveOption]="ordersPerPage"
              [totalCountOrders]="totalCountOrders"
              [allPages]="allPages"
              [activePage]="activePage"
              [totalPages]="totalPages"
              [message]="chooseEmptyMessage()"
              (changeFilter)="onChangeTableFilter($event)"
              (sort)="sortColumns($event)"
              (reSyncOrder)="reSyncOrderClick($event)"
              (changePerPage)="onChangeOrdersPerPage($event)"
              (changePage)="paginate($event)"
              (onTableActivate)="onTableActivate($event)"
              (jumpToOrderTable)="onTableJump($event)"
              (jumpToPage)="jumpToPage($event)"
              (changeColorCoding)="changeColorCoding($event)"></app-table>
          </div>
        }
      }
    </mat-drawer-content>
  </mat-drawer-container>
</div>
